/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Rename_ValidationInputs */

const en_explorer_info_rename_validation = /** @type {(inputs: Explorer_Info_Rename_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name cannot be empty`)
};

const fr_explorer_info_rename_validation = /** @type {(inputs: Explorer_Info_Rename_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nom ne peut pas etre vide`)
};

const de_explorer_info_rename_validation = /** @type {(inputs: Explorer_Info_Rename_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Name darf nicht leer sein.`)
};

const it_explorer_info_rename_validation = /** @type {(inputs: Explorer_Info_Rename_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il nome non può essere vuoto`)
};

const ru_explorer_info_rename_validation = /** @type {(inputs: Explorer_Info_Rename_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя не может быть пустым.`)
};

const es_explorer_info_rename_validation = /** @type {(inputs: Explorer_Info_Rename_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El nombre no puede estar vacío`)
};

const zh_cn2_explorer_info_rename_validation = /** @type {(inputs: Explorer_Info_Rename_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名称不能为空`)
};

const ja_explorer_info_rename_validation = /** @type {(inputs: Explorer_Info_Rename_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前は空欄にできません`)
};

const hi_explorer_info_rename_validation = /** @type {(inputs: Explorer_Info_Rename_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम खाली नहीं हो सकता`)
};

const pt_pt2_explorer_info_rename_validation = /** @type {(inputs: Explorer_Info_Rename_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nome não pode estar vazio.`)
};

/**
* | output |
* | --- |
* | "Name cannot be empty" |
*
* @param {Explorer_Info_Rename_ValidationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_rename_validation = /** @type {((inputs?: Explorer_Info_Rename_ValidationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Rename_ValidationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_rename_validation(inputs)
	if (locale === "de") return de_explorer_info_rename_validation(inputs)
	if (locale === "it") return it_explorer_info_rename_validation(inputs)
	if (locale === "ru") return ru_explorer_info_rename_validation(inputs)
	if (locale === "es") return es_explorer_info_rename_validation(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_rename_validation(inputs)
	if (locale === "ja") return ja_explorer_info_rename_validation(inputs)
	if (locale === "hi") return hi_explorer_info_rename_validation(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_rename_validation(inputs)
	return en_explorer_info_rename_validation(inputs)
});